import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import React from 'react'
import { SelectionType } from 'types/SelectionType'

interface AnswerButtonsProps {
  className?: string
  currentSelection?: Set<string>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleAnswer: (answer: any) => void
  responses: { [key: string]: string }
  selectionType?: SelectionType
}

/**
 * Displays a list of options in the form of a vertical list of buttons. This
 * is functionally the same as the buttons in the questions component, without
 * the fancy colouration.
 * @param className - Any additional classes to be used in the buttons group.
 * @param responses - The list of possible responses
 * @param handleAnswer - onClick handler
 * @param currentSelection - Which option currently has been selected
 * @param selectionType -
 */
const AnswerButtons = ({
  className = '',
  responses,
  handleAnswer,
  currentSelection = new Set(),
  selectionType = 'exclusive'
}: AnswerButtonsProps) => (
  <div
    className={`ui vertical labeled icon ${className} buttons answer-buttons`}
  >
    {Object.entries(responses).map(([value, displayText]) => {
      const handler = () => handleAnswer(value)
      let className = 'icon '
      className += selectionType === 'exclusive' ? 'circle ' : 'square '
      className += currentSelection.has(value) ? 'check' : 'outline'

      return (
        <button onClick={handler} className='ui button' key={value}>
          <i className={className} />
          {displayText}
        </button>
      )
    })}
  </div>
)

export { AnswerButtons }
